import { Link, NavLink } from "react-router-dom";
import { Search, ShoppingBag, Menu, X } from "lucide-react";
import { useState } from "react";
import { useCart, cartCount } from "@/store/cartStore";

const NAV = [
  { label: "Home", to: "/" },
  { label: "Master Models", to: "/category/master-models" },
  { label: "Finished Products", to: "/category/finished-products" },
  { label: "STL Files", to: "/category/stl-files" },
  { label: "Silicone Molds", to: "/category/silicone-molds" },
  { label: "About", to: "/about" },
  { label: "Contact", to: "/contact" },
];

export const Header = ({ onSearchOpen }) => {
  const items = useCart((s) => s.items);
  const count = cartCount(items);
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="sticky top-0 z-40 backdrop-blur-xl bg-[#FFFDF8]/85 border-b border-[#ECECEC]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="header-logo" className="flex items-center gap-2 shrink-0">
          <span className="font-heading font-extrabold text-xl sm:text-2xl gg-gradient-text tracking-tight">
            GlowinGifts
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-1">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              data-testid={`nav-${n.label.toLowerCase().replace(/\s/g, "-")}`}
              className={({ isActive }) =>
                `px-3 py-2 rounded-full text-sm font-medium transition-colors ${
                  isActive ? "text-[#9D00FF] bg-[#9D00FF]/5" : "text-[#666666] hover:text-[#222222]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-1">
          <button
            onClick={onSearchOpen}
            data-testid="header-search-btn"
            aria-label="Search"
            className="min-h-[48px] min-w-[48px] flex items-center justify-center rounded-full text-[#666666] hover:text-[#222222] hover:bg-[#F8F8F8] transition-colors"
          >
            <Search size={21} />
          </button>
          <Link
            to="/cart"
            data-testid="header-cart-btn"
            aria-label="Cart"
            className="relative min-h-[48px] min-w-[48px] flex items-center justify-center rounded-full text-[#666666] hover:text-[#222222] hover:bg-[#F8F8F8] transition-colors"
          >
            <ShoppingBag size={21} />
            {count > 0 && (
              <span
                data-testid="header-cart-count"
                className="absolute top-1.5 right-1.5 min-w-[18px] h-[18px] px-1 rounded-full gg-gradient text-white text-[10px] font-bold flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </Link>
          <button
            onClick={() => setMenuOpen(!menuOpen)}
            data-testid="header-menu-btn"
            aria-label="Menu"
            className="lg:hidden min-h-[48px] min-w-[48px] flex items-center justify-center rounded-full text-[#666666] hover:bg-[#F8F8F8]"
          >
            {menuOpen ? <X size={22} /> : <Menu size={22} />}
          </button>
        </div>
      </div>

      {menuOpen && (
        <nav data-testid="mobile-menu" className="lg:hidden border-t border-[#ECECEC] bg-[#FFFDF8] px-4 py-3">
          {NAV.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              onClick={() => setMenuOpen(false)}
              className={({ isActive }) =>
                `block px-4 py-3 rounded-xl text-base font-medium min-h-[48px] ${
                  isActive ? "text-[#9D00FF] bg-[#9D00FF]/5" : "text-[#666666]"
                }`
              }
            >
              {n.label}
            </NavLink>
          ))}
        </nav>
      )}
    </header>
  );
};

export default Header;
